import { BASE_API_URL } from "utils/constants";
import { downloadFilePost, get, post, put } from '../../utils/api';
import { DataResponse } from "services/response";
import { number } from "echarts";


// ================================ CAMPAIGN =================================================================
// Danh sách nội dung
export interface ContentModel {
  stt: number;
  id: string;
  // Mã nội dung
  contentCode: string;
  // Tên nội dung
  contentName: string;
  // Trạng thái
  actived: boolean;
  // Người tạo
  createBy: string;
  // Ngày tạo
  createTime: string;

  fileUrl: string;
}

// Danh sách campaign
export interface CampaignModel {
  stt: number;
  id: string;
  campaignCode: string;
  campaignName: string;
  revenue?: number;
  sendType?: string;
  statusSend: string;
  createTime?: string;
  createBy: string
  scheduledToStart?: string;
  customerSegmentationId?: string;
  customerSegmentationName?: string;
  isImmediately?: boolean;
  description?: string;
  contentId?: string;
  contentName?: string;
  status?: string;
  saleOrg?: string;
}

// Doanh số theo campaign
export interface RevenueCampaignModel {
  monthCreate: string;
  revenue?: number;
  totalKH?: number;
}

export type ColumnChartModel = {
  value: number,
  name: string
}

// ============ Khai báo phương thức =====================

export interface ICampaignServices {
  // ===================CONTENT ===============================================
  // Danh sách nội dung của Campaign
  getListContent(data: object): Promise<DataResponse<Array<ContentModel>>>
  // Thêm mới nội dung campaign
  createContent(data: object): Promise<DataResponse<null>>
  // chi tiết nội dung
  getContentDetails(contentId: string): Promise<DataResponse<ContentModel | undefined>>
  // Chỉnh sửa nội dung
  editContent(data: object): Promise<DataResponse<null>>

  // =================== CAMPAIGN ============================================
  // Danh sách campaign
  getListCampaign(data: object): Promise<DataResponse<Array<CampaignModel>>>
  // Tạo chiến dịch
  createCampaign(data: object): Promise<DataResponse<null>>
  // chi tiết nội dung
  getCampaignDetails(campaignId: string): Promise<DataResponse<CampaignModel | undefined>>
  // Chỉnh sửa nội dung
  editCampaign(data: object): Promise<DataResponse<null>>
  // Biểu đồ doanh số theo campaign
  getRevenueCampaign(year: number, campaignCode?: string): Promise<DataResponse<Array<RevenueCampaignModel>>>
  // Biểu đồ số lượng KH ghé thăm theo campaign
  getAppointmentCampaign(year: number, campaignCode?: string): Promise<DataResponse<Array<RevenueCampaignModel>>>


  // Biểu đồ đồ thị trong chi tiết campaign
  getDataBarChartReport(campaignId: string): Promise<DataResponse<Array<ColumnChartModel>>>


  // export excel quản lý campaign
  exportExcelCampaign(data: object): Promise<void>

}
// Hàm khởi tạo các phương thức của Báo cáo bảo hành và khiếu nại service
export function createCampaignServices(): ICampaignServices {
  return {
    // ===================CONTENT =============================================================================================
    // Danh sách nội dung của Campaign
    getListContent: async (data) => {
      return (await post(BASE_API_URL, `Campaign/list-content`, data)).data;
    },
    // Thêm mới nội dung campaign
    createContent: async (data) => {
      return (await post(BASE_API_URL, `Campaign/create-content`, data)).data;
    },
    // chi tiết nội dung
    getContentDetails: async (contentId) => {
      return (await get(BASE_API_URL, `Campaign/get-content/${contentId}`)).data
    },
    // Chỉnh sửa nội dung
    editContent: async (data) => {
      return (await post(BASE_API_URL, `Campaign/edit-content`, data)).data;
    },

    // =================== CAMPAIGN ===================================================================================
    // Danh sách campaign
    getListCampaign: async (data) => {
      return (await post(BASE_API_URL, `Campaign/list-campaign`, data)).data;
    },
    // Tạo chiến dịch
    createCampaign: async (data) => {
      return (await post(BASE_API_URL, `Campaign/create-campaign`, data)).data;
    },
    // chi tiết campaign
    getCampaignDetails: async (campaignId) => {
      return (await get(BASE_API_URL, `Campaign/get-campaign/${campaignId}`)).data
    },
    // Chỉnh sửa campaign
    editCampaign: async (data) => {
      return (await put(BASE_API_URL, `Campaign/edit-campaign`, data)).data;
    },
    // Biểu đồ doanh số theo campaign
    getRevenueCampaign: async (year, campaignCode) => {
      return (await get(BASE_API_URL, `Campaign/revenue-campaign/${year}`, { CampaignCode: campaignCode })).data;
    },
    // Biểu đồ số lượng KH ghé thăm theo campaign
    getAppointmentCampaign: async (year, campaignCode) => {
      return (await get(BASE_API_URL, `Campaign/appointment-campaign/${year}`, { CampaignCode: campaignCode })).data;
    },

    // Biểu đồ đồ thị trong chi tiết campaign
    getDataBarChartReport: async (id) => {
      return (await get(BASE_API_URL, `Campaign/report/` + id)).data;
    },

    // Xuât Excel báo cáo
    exportExcelCampaign: async (data) => {
      await downloadFilePost('Campaign/export-excel-campaign', data)
    }
  };
}
